// TODO: выпилить, когда появится вторая константа
// eslint-disable-next-line import/prefer-default-export
export const TABLE_FILTERS = {
    feat: {
        status: [
            {
                value: 'draft',
                label: 'Черновик',
            },
        ],
        tag: [
            {
                value: 'hard',
                label: 'Железо и софт',
            },
            {
                value: 'partner',
                label: 'Партнерский материал',
            },
            {
                value: '18plus',
                label: '18+',
            },
        ],
    },
    news: {
        status: [
            {
                value: 'draft',
                label: 'Черновик',
            },
        ],
        tag: [
            {
                value: 'cybersport',
                label: 'Киберспорт',
            },
        ],
    },
    review: {
        status: [
            {
                value: 'draft',
                label: 'Черновик',
            },
        ],
    },
    secret: {
        status: [
            {
                value: 'draft',
                label: 'Черновик',
            },
            {
                value: 'moderation',
                label: 'На модерации',
            },
        ],
    },
};
